export const mfaTypeMap = {
  email: "Email:",
  sms: "Text Message:",
  totp: "Authenticator App",
};

export const mfaTypeMapWithSetup = {
  email: "Email",
  sms: "SMS/Text",
  totp: "Authenticator",
};
